import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd/lib/grid';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import './style.scss';
import { Props } from './typing';
import InputField from '../../../../../../components/TextInput';
import SelectDropdown from '../../../../../../components/Select';
import ProfileFooter from '../ProfileFooter';
import CustomSwitch from '../../../../../../components/CustomSwitch';
import {
  urlValidationRgex,
  alphabetValidationRegex,
  numericValidationRegex,
  nonEmptyValidationRegex,
} from '../../../../../../lib/constants';
import { businessCategory, countryCode } from './constants';
import {
  getStateAction,
  getCityAction,
} from '../../../../../../redux/actions/completeProfile';
import Textarea from '../../../../../../components/Textarea';

const BusinessInformationDetails: FC<Props> = (props): JSX.Element => {
  const {
    nextPage,
    prevPage,
    currentStep,
    setCurrentStep,
    merchantProfile,
    updateProfileDetails,
    validationErrors,
    getStateAction,
    getCityAction,
    getStateState,
    getCityState,
  } = props;

  const [sameAdress, setSameAddress] = useState(
    merchantProfile?.businessinformation?.RegisteredAddress &&
      merchantProfile?.businessinformation?.RegisteredAddress !== '' &&
      merchantProfile?.businessinformation?.RegisteredAddress ===
        merchantProfile?.businessinformation?.OperationalAddress &&
      merchantProfile?.businessinformation?.RegisteredPincode ===
        merchantProfile?.businessinformation?.OperationalPincode &&
      merchantProfile?.businessinformation?.RegisteredState ===
        merchantProfile?.businessinformation?.OperationalState &&
      merchantProfile?.businessinformation?.RegisteredCity ===
        merchantProfile?.businessinformation?.OperationalCity
  );
  const [displayCategoryList] = useState([
    ...businessCategory.map((item) => ({
      value: item.value,
      label: item.label,
    })),
  ]);
  const [displaySubCategoryList, setDisplaySubCategoryList] = useState<any>();
  const [stateList, setStateList] = useState<any>([]);
  const [registeredcityList, setRegisteredCityList] = useState<any>([]);
  const [operationalcityList, setOperationalCityList] = useState<any>([]);

  const formik = useFormik({
    initialValues: {
      Merchant_Website:
        merchantProfile?.businessinformation?.Merchant_Website || '',
      ReturnURL: merchantProfile?.businessinformation?.ReturnURL || '',
      NatureOfBusinees:
        merchantProfile?.businessinformation?.NatureOfBusinees || '',
      BusinessCategory:
        merchantProfile?.businessinformation?.BusinessCategory || '',
      MerchantCategory:
        merchantProfile?.businessinformation?.MerchantCategory || '',
      NoOfYearsinBusiness:
        merchantProfile?.businessinformation?.NoOfYearsinBusiness || '',
      AnnualTurnover:
        merchantProfile?.businessinformation?.AnnualTurnover || '',
      MonthlyCardTurnover:
        merchantProfile?.businessinformation?.MonthlyCardTurnover || '',
      ExpectedNoOfTransactions:
        merchantProfile?.businessinformation?.ExpectedNoOfTransactions || '',
      MinTicketSize: merchantProfile?.businessinformation?.MinTicketSize || '',
      MaxTicketSize: merchantProfile?.businessinformation?.MaxTicketSize || '',

      RegisteredAddress:
        merchantProfile?.businessinformation?.RegisteredAddress || '',
      RegisteredPincode:
        merchantProfile?.businessinformation?.RegisteredPincode || '',
      RegisteredState:
        merchantProfile?.businessinformation?.RegisteredState || '',
      RegisteredCity:
        merchantProfile?.businessinformation?.RegisteredCity || '',
      OperationalAddress:
        merchantProfile?.businessinformation?.OperationalAddress || '',
      OperationalPincode:
        merchantProfile?.businessinformation?.OperationalPincode || '',
      OperationalState:
        merchantProfile?.businessinformation?.OperationalState || '',
      OperationalCity:
        merchantProfile?.businessinformation?.OperationalCity || '',
    },
    validationSchema: Yup.object({
      Merchant_Website: Yup.string()
        .trim()
        .matches(urlValidationRgex, validationErrors.INVALID_URL),
      ReturnURL: Yup.string()
        .trim()
        .matches(urlValidationRgex, validationErrors.INVALID_URL),
      NatureOfBusinees: Yup.string()
        .matches(nonEmptyValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      BusinessCategory: Yup.string()
        .matches(alphabetValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      MerchantCategory: Yup.string()
        .matches(nonEmptyValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      NoOfYearsinBusiness: Yup.string()
        .matches(numericValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      AnnualTurnover: Yup.string()
        .matches(numericValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      MonthlyCardTurnover: Yup.string()
        .matches(numericValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      ExpectedNoOfTransactions: Yup.string()
        .matches(numericValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      MinTicketSize: Yup.string()
        .matches(numericValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      MaxTicketSize: Yup.string()
        .matches(numericValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),

      RegisteredAddress: Yup.string()
        .matches(alphabetValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      RegisteredPincode: Yup.string()
        .matches(numericValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      RegisteredState: Yup.string()
        .matches(alphabetValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      RegisteredCity: Yup.string()
        .matches(nonEmptyValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      OperationalAddress: Yup.string()
        .matches(alphabetValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      OperationalPincode: Yup.string()
        .matches(numericValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      OperationalState: Yup.string()
        .matches(alphabetValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      OperationalCity: Yup.string()
        .matches(nonEmptyValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
    }),
    onSubmit: () => {},
  });

  const callFormSubmit = (step, statusData) => {
    const merchantProfileValue = {
      ...merchantProfile,
      businessinformation: {
        ...formik.values,
      },
    };
    updateProfileDetails(step, statusData, merchantProfileValue);
  };

  const enableSave = () => {
    return (
      Object.keys(formik.values).filter((key) => {
        return formik.values[key] !== '';
      }).length > 0
    );
  };

  const getCityname = (param) => {
    try{
      return JSON.parse(param).name;
    } catch(e) {
      return param;
    }
  };

  const enableSaveAndNext = () => {
    return (
      formik.values.Merchant_Website !== '' &&
      formik.values.ReturnURL !== '' &&
      formik.values.NatureOfBusinees !== '' &&
      formik.values.BusinessCategory !== '' &&
      formik.values.MerchantCategory !== '' &&
      formik.values.NoOfYearsinBusiness !== '' &&
      formik.values.AnnualTurnover !== '' &&
      formik.values.MonthlyCardTurnover !== '' &&
      formik.values.ExpectedNoOfTransactions !== '' &&
      formik.values.MinTicketSize !== '' &&
      formik.values.MaxTicketSize !== '' &&
      formik.values.RegisteredAddress !== '' &&
      formik.values.RegisteredPincode !== '' &&
      formik.values.RegisteredState !== '' &&
      formik.values.RegisteredCity !== '' &&
      formik.values.OperationalAddress !== '' &&
      formik.values.OperationalPincode !== '' &&
      formik.values.OperationalState !== '' &&
      formik.values.OperationalCity !== '' &&
      !(
        formik.errors.Merchant_Website ||
        formik.errors.ReturnURL ||
        formik.errors.NatureOfBusinees ||
        formik.errors.BusinessCategory ||
        formik.errors.MerchantCategory ||
        formik.errors.NoOfYearsinBusiness ||
        formik.errors.AnnualTurnover ||
        formik.errors.MonthlyCardTurnover ||
        formik.errors.ExpectedNoOfTransactions ||
        formik.errors.MinTicketSize ||
        formik.errors.MaxTicketSize ||
        formik.errors.RegisteredAddress ||
        formik.errors.RegisteredPincode ||
        formik.errors.RegisteredState ||
        formik.errors.RegisteredCity ||
        formik.errors.OperationalAddress ||
        formik.errors.OperationalPincode ||
        formik.errors.OperationalState ||
        formik.errors.OperationalCity
      )
    );
  };

  useEffect(() => {
    getStateAction(countryCode);
  }, []);

  useEffect(() => {
    const { isSuccess, data } = getStateState;
    if (isSuccess && data) {
      setStateList(data);
    }
  }, [getStateState]);

  useEffect(() => {
    const { isSuccess, data, target } = getCityState;
    if (isSuccess && data) {
      if(sameAdress) {
        setRegisteredCityList(data.map(item => ({label: item.name, value:JSON.stringify(item)})));
      } else {
        if (target === 'RegisteredState') {
          setRegisteredCityList(data.map(item => ({label: item.name, value:JSON.stringify(item)})));
        }
  
        if (target === 'OperationalState') {
          setOperationalCityList(data.map(item => ({label: item.name, value:JSON.stringify(item)})));
        }
      }
     
    }
  }, [getCityState]);

  useEffect(() => {
    const selectedStatecode = stateList.filter(
      (item) => item.name === formik.values.RegisteredState
    );
    if (selectedStatecode.length === 1) {
      getCityAction(selectedStatecode[0].code, 'RegisteredState');
    }
  }, [formik.values.RegisteredState]);

  useEffect(() => {
    const selectedStatecode = stateList.filter(
      (item) => item.name === formik.values.OperationalState
    );
    if (selectedStatecode.length === 1) {
      getCityAction(selectedStatecode[0].code, 'OperationalState');
    }
  }, [formik.values.OperationalState]);

  useEffect(() => {
    if (formik.values.BusinessCategory !== '') {
      formik.setFieldValue('MerchantCategory', '');
      const subcategorieslist = businessCategory.filter((item) => {
        return item.value === formik.values.BusinessCategory;
      })[0].subCategory;
      const sublist: any = [];
      subcategorieslist.forEach((subcat: any) => {
        subcat.merchantCategory.forEach((merCat) => {
          if (merCat.required) {
            sublist.push({
              label: merCat.label,
              value: JSON.stringify({
                subCategory: subcat.value,
                merchantCategory: merCat.value,
              }),
            });
          }
        });
      });
      setDisplaySubCategoryList(sublist);
    }
  }, [formik.values.BusinessCategory]);

  useEffect(() => {
    if (sameAdress) {
      formik.setFieldValue(
        'OperationalAddress',
        formik.values.RegisteredAddress
      );
      formik.setFieldValue(
        'OperationalPincode',
        formik.values.RegisteredPincode
      );
      formik.setFieldValue('OperationalState', formik.values.RegisteredState);
      formik.setFieldValue('OperationalCity', formik.values.RegisteredCity);
    } else {
      formik.setFieldValue('OperationalAddress', '');
      formik.setFieldValue('OperationalPincode', '');
      formik.setFieldValue('OperationalState', '');
      formik.setFieldValue('OperationalCity', '');
    }
  }, [
    sameAdress,
    formik.values.RegisteredAddress,
    formik.values.RegisteredPincode,
    formik.values.RegisteredState,
    formik.values.RegisteredCity,
  ]);

  useEffect(() => {
    if (merchantProfile?.companyauthdetails) {
      formik.setValues({
        ...formik.values,
        Merchant_Website:
          merchantProfile?.businessinformation?.Merchant_Website || '',
        ReturnURL: merchantProfile?.businessinformation?.ReturnURL || '',
        NatureOfBusinees:
          merchantProfile?.businessinformation?.NatureOfBusinees || '',
        BusinessCategory:
          merchantProfile?.businessinformation?.BusinessCategory || '',
        MerchantCategory:
          merchantProfile?.businessinformation?.MerchantCategory || '',
        NoOfYearsinBusiness:
          merchantProfile?.businessinformation?.NoOfYearsinBusiness || '',
        AnnualTurnover:
          merchantProfile?.businessinformation?.AnnualTurnover || '',
        MonthlyCardTurnover:
          merchantProfile?.businessinformation?.MonthlyCardTurnover || '',
        ExpectedNoOfTransactions:
          merchantProfile?.businessinformation?.ExpectedNoOfTransactions || '',
        MinTicketSize:
          merchantProfile?.businessinformation?.MinTicketSize || '',
        MaxTicketSize:
          merchantProfile?.businessinformation?.MaxTicketSize || '',

        RegisteredAddress:
          merchantProfile?.businessinformation?.RegisteredAddress || '',
        RegisteredPincode:
          merchantProfile?.businessinformation?.RegisteredPincode || '',
        RegisteredState:
          merchantProfile?.businessinformation?.RegisteredState || '',
        OperationalAddress:
          merchantProfile?.businessinformation?.OperationalAddress || '',
        OperationalPincode:
          merchantProfile?.businessinformation?.OperationalPincode || '',
        OperationalState:
          merchantProfile?.businessinformation?.OperationalState || '',
      });
    }
  }, [merchantProfile?.businessinformation]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className='kyc-businessinfo-details'>
        <div className='title'>Business Information</div>
        <Row>
          <Col span={10}>
            <div className='content-text'>
            </div>
          </Col>
        </Row>
        <div className='business-website-details'>
          <div className='dir-title'>Website Details</div>
          <div className='dir-content'>
          </div>
        </div>
        <div className='plural-business-website-details'>
          <Row>
            <Col span={6}>
              <InputField
                name='Merchant_Website'
                type='url'
                label='Business Website URL'
                isRequired={true}
                value={formik.values.Merchant_Website}
                placeholder='https://example.com'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.Merchant_Website &&
                    formik.errors.Merchant_Website
                )}
                errorMessage={formik.errors.Merchant_Website?.toString()}
              />
            </Col>
            <Col span={6} offset={2}>
              <InputField
                name='ReturnURL'
                type='url'
                label='Return URL'
                isRequired={true}
                value={formik.values.ReturnURL}
                placeholder='https://example.com'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.ReturnURL && formik.errors.ReturnURL
                )}
                errorMessage={formik.errors.ReturnURL?.toString()}
              />
            </Col>
          </Row>
          <div className='divider' />
        </div>

        <div className='business-structure-details'>
          <div className='dir-title'>Business Structure</div>
          <div className='dir-content'>
          </div>
        </div>
        <div className='plural-business-structure-details'>
          <Row>
            <Col span={14}>
              <Textarea
                name='NatureOfBusinees'
                label='Nature of Business'
                customStyleClass='business_nature_text'
                isRequired={true}
                value={formik.values.NatureOfBusinees}
                placeholder='Nature of Business'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                rows={3}
                maxlength={50}
                error={Boolean(
                  formik.touched.NatureOfBusinees &&
                    formik.errors.NatureOfBusinees
                )}
                errorMessage={formik.errors.NatureOfBusinees?.toString()}
              />
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <div className={`form-group`}>
                <label>
                  Business Category<em>*</em>
                </label>
                <SelectDropdown
                  enableSearch={true}
                  wrapperClass='form-control'
                  value={formik.values.BusinessCategory}
                  onChange={(value) => {
                    formik.setFieldValue('BusinessCategory', value);
                  }}
                  optionList={displayCategoryList}
                  error={Boolean(
                    formik.touched.BusinessCategory &&
                      formik.errors.BusinessCategory
                  )}
                  errorMessage={formik.errors.BusinessCategory?.toString()}
                />
              </div>
            </Col>
            <Col span={6} offset={2}>
              <div className={`form-group`}>
                <label>
                  Business Sub-Category<em>*</em>
                </label>
                <SelectDropdown
                  enableSearch={displaySubCategoryList && displaySubCategoryList?.length > 5}
                  wrapperClass='form-control'
                  value={formik.values.MerchantCategory}
                  onChange={(value) => {
                    formik.setFieldValue('MerchantCategory', value);
                  }}
                  optionList={displaySubCategoryList}
                  error={Boolean(
                    formik.touched.MerchantCategory &&
                      formik.errors.MerchantCategory
                  )}
                  errorMessage={formik.errors.MerchantCategory?.toString()}
                />
              </div>
            </Col>
          </Row>
          <Row></Row>
          <div className='divider' />
        </div>

        <div className='business-address-details'>
          <div className='dir-title'>Registered Business Address</div>
          <div className='dir-content'>
          </div>
        </div>
        <div className='plural-business-address-details'>
          <Row>
            <Col span={14}>
              <InputField
                name='RegisteredAddress'
                type='text'
                label='Address'
                isRequired={true}
                value={formik.values.RegisteredAddress}
                placeholder='Business Address'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.RegisteredAddress &&
                    formik.errors.RegisteredAddress
                )}
                errorMessage={formik.errors.RegisteredAddress?.toString()}
              />
            </Col>
          </Row>

          <Row>
            <Col span={4}>
              <InputField
                name='RegisteredPincode'
                type='number'
                label='Business Pincode'
                isRequired={true}
                value={formik.values.RegisteredPincode}
                placeholder='Pincode'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.RegisteredPincode &&
                    formik.errors.RegisteredPincode
                )}
                errorMessage={formik.errors.RegisteredPincode?.toString()}
              />
            </Col>
            <Col span={4} offset={1}>
              <div className={`form-group`}>
                <label>
                  State<em>*</em>
                </label>
                <SelectDropdown
                  enableSearch={stateList.length > 5}
                  wrapperClass='form-control'
                  value={formik.values.RegisteredState}
                  onChange={(value) => {
                    formik.setFieldValue('RegisteredState', value);
                  }}
                  optionList={stateList.map((item) => ({
                    value: item.name,
                    label: item.name,
                  }))}
                  error={Boolean(
                    formik.touched.RegisteredState &&
                      formik.errors.RegisteredState
                  )}
                  errorMessage={formik.errors.RegisteredState?.toString()}
                />
              </div>
            </Col>
            <Col span={4} offset={1}>
              <div className={`form-group`}>
                <label>
                  City<em>*</em>
                </label>
                <SelectDropdown
                  enableSearch={registeredcityList.length > 5}
                  wrapperClass='form-control'
                  value={getCityname(formik.values.RegisteredCity)}
                  onChange={(value) => {
                    formik.setFieldValue('RegisteredCity', value);
                  }}
                  optionList={registeredcityList}
                  error={Boolean(
                    formik.touched.RegisteredCity &&
                      formik.errors.RegisteredCity
                  )}
                  errorMessage={formik.errors.RegisteredCity?.toString()}
                />
              </div>
            </Col>
          </Row>
          <div className='divider' />
        </div>

        <div className='business-address-details'>
          <div className='dir-title'>Operational Business Address</div>
          <div className='dir-content'>
          </div>
          <div className='same-address-wrapper'>
            <CustomSwitch
              onChange={(value: boolean) => {
                setSameAddress(value);
              }}
              checked={sameAdress}
            />{' '}
            Same as Registered Business Address
          </div>
        </div>
        <div className='plural-business-address-details'>
          <Row>
            <Col span={14}>
              <InputField
                name='OperationalAddress'
                type='text'
                label='Address'
                isRequired={true}
                value={formik.values.OperationalAddress}
                placeholder='Operational Address'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={sameAdress}
                error={Boolean(
                  formik.touched.OperationalAddress &&
                    formik.errors.OperationalAddress
                )}
                errorMessage={formik.errors.OperationalAddress?.toString()}
              />
            </Col>
          </Row>

          <Row>
            <Col span={4}>
              <InputField
                name='OperationalPincode'
                type='number'
                label='Operational Pincode'
                isRequired={true}
                value={formik.values.OperationalPincode}
                placeholder='Pincode'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={sameAdress}
                error={Boolean(
                  formik.touched.OperationalPincode &&
                    formik.errors.OperationalPincode
                )}
                errorMessage={formik.errors.OperationalPincode?.toString()}
              />
            </Col>
            <Col span={4} offset={1}>
              <div className={`form-group`}>
                <label>
                  State<em>*</em>
                </label>
                <SelectDropdown
                  enableSearch={stateList.length > 5}
                  wrapperClass='form-control'
                  value={formik.values.OperationalState}
                  onChange={(value) => {
                    formik.setFieldValue('OperationalState', value);
                  }}
                  optionList={stateList.map((item) => ({
                    value: item.name,
                    label: item.name,
                  }))}
                  disabled={sameAdress}
                  error={Boolean(
                    formik.touched.OperationalState &&
                      formik.errors.OperationalState
                  )}
                  errorMessage={formik.errors.OperationalState?.toString()}
                />
              </div>
            </Col>
            <Col span={4} offset={1}>
              <div className={`form-group`}>
                <label>
                  City<em>*</em>
                </label>
                <SelectDropdown
                  enableSearch={operationalcityList.length > 5}
                  wrapperClass='form-control'
                  value={getCityname(formik.values.OperationalCity)}
                  onChange={(value) => {
                    formik.setFieldValue('OperationalCity', value);
                  }}
                  optionList={operationalcityList}
                  disabled={sameAdress}
                  error={Boolean(
                    formik.touched.OperationalCity &&
                      formik.errors.OperationalCity
                  )}
                  errorMessage={formik.errors.OperationalCity?.toString()}
                />
              </div>
            </Col>
          </Row>
          <div className='divider' />
        </div>

        <div className='business-details'>
          <div className='dir-title'>Business Details</div>
          <div className='dir-content'>
          </div>
        </div>
        <div className='plural-business-details'>
          <Row>
            <Col span={6}>
              <InputField
                name='NoOfYearsinBusiness'
                type='number'
                label='No of Years in Business'
                isRequired={true}
                value={formik.values.NoOfYearsinBusiness}
                placeholder='12'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.NoOfYearsinBusiness &&
                    formik.errors.NoOfYearsinBusiness
                )}
                errorMessage={formik.errors.NoOfYearsinBusiness?.toString()}
              />
            </Col>
            <Col span={6} offset={2}>
              <InputField
                name='AnnualTurnover'
                type='number'
                label='Annual Turnover'
                isRequired={true}
                value={formik.values.AnnualTurnover}
                placeholder='12345'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.AnnualTurnover && formik.errors.AnnualTurnover
                )}
                errorMessage={formik.errors.AnnualTurnover?.toString()}
              />
            </Col>
          </Row>

          <Row>
            <Col span={6}>
              <InputField
                name='MonthlyCardTurnover'
                type='number'
                label='Expected Monthly Card Turnover'
                isRequired={true}
                value={formik.values.MonthlyCardTurnover}
                placeholder='12345'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.MonthlyCardTurnover &&
                    formik.errors.MonthlyCardTurnover
                )}
                errorMessage={formik.errors.MonthlyCardTurnover?.toString()}
              />
            </Col>
            <Col span={6} offset={2}>
              <InputField
                name='ExpectedNoOfTransactions'
                type='number'
                label='Expected no of transactions on website per month'
                isRequired={true}
                value={formik.values.ExpectedNoOfTransactions}
                placeholder='12345'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.ExpectedNoOfTransactions &&
                    formik.errors.ExpectedNoOfTransactions
                )}
                errorMessage={formik.errors.ExpectedNoOfTransactions?.toString()}
              />
            </Col>
          </Row>

          <Row>
            <Col span={6}>
              <InputField
                name='MinTicketSize'
                type='number'
                label='Minimum Ticket Size'
                isRequired={true}
                value={formik.values.MinTicketSize}
                placeholder='12345'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.MinTicketSize && formik.errors.MinTicketSize
                )}
                errorMessage={formik.errors.MinTicketSize?.toString()}
              />
            </Col>
            <Col span={6} offset={2}>
              <InputField
                name='MaxTicketSize'
                type='number'
                label='Maximum Ticket Size'
                isRequired={true}
                value={formik.values.MaxTicketSize}
                placeholder='12345'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={false}
                error={Boolean(
                  formik.touched.MaxTicketSize && formik.errors.MaxTicketSize
                )}
                errorMessage={formik.errors.MaxTicketSize?.toString()}
              />
            </Col>
          </Row>
          <div className='divider' />
        </div>
      </div>
      <ProfileFooter
        nextPage={nextPage}
        prevPage={prevPage}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        saveAction={callFormSubmit}
        enableSave={enableSave()}
        enableSaveAndNext={enableSaveAndNext()}
      />
    </form>
  );
};

const mapStateToProps = ({ validationReducer, completeProfileReducer }) => ({
  validationErrors: validationReducer.validationErrorState.validationErrors,
  getStateState: completeProfileReducer.getStateState,
  getCityState: completeProfileReducer.getCityState,
});

export default connect(mapStateToProps, {
  getStateAction,
  getCityAction,
})(BusinessInformationDetails);
